module.exports = __webpack_public_path__ + "5ad9d79f.png";